import { render, staticRenderFns } from "./MembersDialog.vue?vue&type=template&id=2dea00c8"
import script from "./MembersDialog.vue?vue&type=script&lang=js"
export * from "./MembersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports